import Dropdown from "app/components/Dropdown";
import {
  CheckboxActiveIcon,
  Input,
  SearchIcon,
  TagIcon,
} from "app/components/Icons";
import CheckboxIcon from "app/components/Icons/CheckboxIcon";
import Pill from "app/components/Pill";
import React, { useEffect, useState } from "react";
import StatusSelectionButton from "./StatusSelectionButton";
import PlusIcon from "app/components/Icons/PlusIcon";
import AddNewTag from "./AddNewTag";
import { ITag } from "app/containers/Features/containers/Boards/types";
import CommonTicketTypeSelection from "app/containers/Features/components/CommonTicketTypeSelection";
import CommonTagSelection from "app/containers/Features/components/CommonTagSelection";
import { selectTagList } from "app/redux/selector";
import { useSelector } from "react-redux";

interface TagsSelectionProps {
  selectedTags?: string[];
  onTagsChange?: (tags: string[]) => void;
}

const TagsSelection: React.FC<TagsSelectionProps> = ({
  selectedTags = [],
  onTagsChange,
}) => {
  //const dispatch = useDispatch();
  const tagList = useSelector(selectTagList);

  const handleSelectionChange = (updatedSelectedItems) => {
    if (onTagsChange) {
      onTagsChange(updatedSelectedItems);
    }
  };
  

  return (
    <>
      <CommonTagSelection
        trigger={
          <button className="flex items-center justify-between w-full px-2 py-2 rounded-md hover:bg-[#F4F5F7] rounded-[4px] data-[state=open]:border-[#79808A] data-[state=open]:outline-[#79808A] data-[state=open]:border-[1px] border-[#79808A]">
            <StatusSelectionButton
              label="Tags:"
              icon={<TagIcon size={18} color="#79808A" />}
              className="text-[12px] leading-[18px] font-medium text-secondary mt-[2px]"
              selectedTag={tagList.filter((tag) =>
                selectedTags?.includes(tag._id)
              )}
              maxSelectedTag={2}
            />
          </button>
        }
        options={tagList}
        className="max-w-[237px] max-h-[260px] py-2"
        selectedTags={selectedTags}
        onTagsChange={(tagIds) => {
          handleSelectionChange(tagIds);
        }}
        align="end"
         isHeader="Tags"
      />
    </>
  );
};

export default TagsSelection;
